export default "__VITE_ASSET__97039652__"